import { bool, func, number, string } from 'prop-types';
import React, { Component } from 'react';
import { FormGroup } from 'ps-design';

export default class JobTitleSearch extends Component {
  static propTypes = {
    titleJobSearch: func,
    workLocationExact: string,
    payscaleJobTitle: string,
    jobCode: string,
    orgJobTitle: string,
    orgJobId: number,
    editJobTitleMode: bool,
    cancelEditJobTitle: func,
    currentMatchSearch: bool,
    hideTitleSearchBox: bool,
    noJobCode: bool,
    feature: string,
    isMP: bool,
    toggleCards: func
  };

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      workLocation: this.props.workLocationExact,
      workLocationValue: this.props.workLocationExact,
      orgJobCode: this.props.jobCode,
      infoDisabled: false,
      jobTitleSearchValue: this.props.payscaleJobTitle ? this.props.payscaleJobTitle : this.props.orgJobTitle
    };
  }

  componentDidMount() {
    if (this.props.feature === 'differentials') this.handleSearchAction();
  }

  handleJobSearchChange(event) {
    if (event && event.target) {
      this.setState({ jobTitleSearchValue: event.target.value });
    } else {
      this.setState({ jobTitleSearchValue: '' });
    }
    if (event.key === 'Enter') {
      this.handleSearchAction();
      if (this.props.isMP) this.props.toggleCards();
    }
  }

  handleSearchAction() {
    if (this.state.jobTitleSearchValue && this.state.jobTitleSearchValue !== '') {
      this.props.titleJobSearch({
        params: {
          orgJobId: this.props.orgJobId,
          title: this.state.jobTitleSearchValue,
          workLocation: this.state.workLocation,
          jobCode: this.state.orgJobCode,
          additionalSearch: true,
          noJobCode: this.props.noJobCode
        }
      });

      if (this.props.feature === 'crowd_source_match') this.props.cancelEditJobTitle();
    }
  }

  submit(e) {
    e.preventDefault();
  }

  render() {
    const { isMP } = this.props;

    return (
      <div className="row add-job__search-title" id="basicJobInfo">
        <div className="search-title__title-block">
          {!isMP && (
            <span className="search-title__title">
              {this.props.editJobTitleMode || this.props.payscaleJobTitle === ''
                ? 'Choose a PayScale Job Title to Continue'
                : 'Your Current Match'}
            </span>
          )}
          {this.props.editJobTitleMode &&
            this.props.feature !== 'differentials' &&
            this.props.feature !== 'crowd_source_match' && (
              <a className="search-title__cancel--btn" onClick={this.props.cancelEditJobTitle}>
                Cancel
              </a>
            )}
        </div>
        {!this.props.hideTitleSearchBox && (
          <form onSubmit={this.submit}>
            <FormGroup className="search-title__input--form pull-right">
              <div className="search-title__input--group btn-group">
                <input
                  className="pxl-form-control search-title__input"
                  id="payscale__job-title-search"
                  type="text"
                  onKeyPress={this.handleJobSearchChange.bind(this)}
                  value={this.state.jobTitleSearchValue ? this.state.jobTitleSearchValue : ''}
                  onChange={this.handleJobSearchChange.bind(this)}
                  placeholder="Search for another job title"
                  autoComplete="off"
                />
                <span className="icon-search search-title__search-icon" onClick={this.handleSearchAction.bind(this)} />
              </div>
            </FormGroup>
          </form>
        )}
        {this.props.editJobTitleMode &&
          (this.props.feature === 'differentials' || this.props.feature === 'crowd_source_match') && (
            <a className="search-title__cancel--btn" onClick={this.props.cancelEditJobTitle}>
              Cancel
            </a>
          )}
      </div>
    );
  }
}
